import React from 'react';
import { motion } from 'framer-motion';

const About: React.FC = () => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    className="max-w-3xl mx-auto py-16 px-6 text-center text-white"
  >
    <h1 className="text-5xl font-bold mb-8 text-fiesta-yellow">About Fantasy Fiesta</h1>
    
    <div className="space-y-6">
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-xl leading-relaxed"
      >
        Fantasy Fiesta offers comprehensive content for fantasy football enthusiasts, catering to both dedicated dynasty players and casual re-drafters. Our offerings include podcasts, player rankings, blogs, and interactive fantasy leagues, promising participants a unique and enriching experience.
      </motion.p>
      
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="text-xl leading-relaxed"
      >
        We are a group that enjoys all aspects of fantasy football and wants to share our love for the game.
      </motion.p>
    </div>
    
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.6, duration: 0.5 }}
      className="mt-12 p-6 border border-fiesta-blue/30 rounded-xl bg-black/30 shadow-lg"
    >
      <p className="text-xl font-semibold text-fiesta-yellow">
        Join the Fiesta for improved football knowledge and to join the rapidly growing fantasy football community.
      </p>
    </motion.div>
  </motion.div>
);

export default About;
